import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize20 {
  size?: '20';
}
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize20 | OverrideIconSize24;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.1 3.89999C15.8165 3.61427 15.4792 3.38751 15.1076 3.23276C14.7361 3.078 14.3375 2.99832 13.935 2.99832C13.5325 2.99832 13.134 3.078 12.7624 3.23276C12.3908 3.38751 12.0535 3.61427 11.77 3.89999L3.83002 11.84L3.02001 15.84C2.9869 16.002 2.99447 16.1697 3.04205 16.328C3.08963 16.4864 3.17573 16.6304 3.29265 16.7473C3.40956 16.8643 3.55365 16.9504 3.712 16.998C3.87035 17.0455 4.03802 17.0531 4.20001 17.02L8.20001 16.2L16.14 8.25998C16.4277 7.9733 16.6552 7.63205 16.8093 7.25626C16.9633 6.88046 17.0407 6.47768 17.037 6.07156C17.0332 5.66544 16.9484 5.26417 16.7876 4.89127C16.6267 4.51836 16.3929 4.18135 16.1 3.89999ZM7.66001 15.23L6.12002 15.55C6.14332 15.3529 6.12118 15.1531 6.05531 14.9659C5.98945 14.7787 5.88159 14.6091 5.74001 14.47C5.56907 14.2965 5.35281 14.1745 5.11589 14.1179C4.87897 14.0613 4.63092 14.0724 4.40002 14.15L4.77001 12.35L5.67001 11.45C6.044 11.452 6.41378 11.5291 6.75736 11.6768C7.10094 11.8246 7.4113 12.0399 7.67001 12.31C7.94147 12.5676 8.1577 12.8778 8.30554 13.2216C8.45339 13.5654 8.52976 13.9357 8.53001 14.31L7.66001 15.23ZM9.47002 13.42C9.28726 12.726 8.92112 12.0939 8.41001 11.59C7.90615 11.0789 7.27407 10.7128 6.58002 10.53L11.44 5.67996C11.8142 5.6808 12.1843 5.75744 12.528 5.90524C12.8718 6.05305 13.182 6.26901 13.44 6.54001C13.7096 6.79907 13.9247 7.10947 14.0724 7.45297C14.2201 7.79647 14.2975 8.16611 14.3 8.54001L9.47002 13.42ZM15.38 7.50998L15.24 7.64999C15.078 6.96089 14.7325 6.3285 14.24 5.81998C13.7356 5.3045 13.099 4.93778 12.4 4.75998L12.54 4.61996L12.66 4.51999C13.0452 4.17561 13.5488 3.99366 14.0651 4.0123C14.5815 4.03094 15.0706 4.2487 15.43 4.61996L15.53 4.73001C15.8711 5.12208 16.0461 5.63147 16.0181 6.15036C15.9901 6.66926 15.7613 7.15688 15.38 7.50998Z"
          fill={color}
        />
      </svg>
    );
  }
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.8 3.19003C20.0336 2.42732 18.9963 1.99911 17.915 1.99911C16.8338 1.99911 15.7965 2.42732 15.03 3.19003L13.5 4.71994L5.37003 12.83L3.44003 14.75C3.30524 14.8843 3.21158 15.0543 3.17003 15.24L2.27003 19.13C2.22815 19.2495 2.20128 19.3738 2.19003 19.5L2.04003 20.13C1.98252 20.3781 1.98912 20.6367 2.0592 20.8816C2.12928 21.1264 2.26054 21.3493 2.44062 21.5294C2.62069 21.7095 2.84364 21.8408 3.08847 21.9109C3.3333 21.9809 3.59195 21.9875 3.84003 21.93L4.48003 21.78L4.83003 21.7L8.74003 20.8C8.92341 20.7525 9.09191 20.6596 9.23003 20.53L11.16 18.5999L19.28 10.5L20.8 8.97995C21.1807 8.60005 21.4827 8.14883 21.6888 7.65207C21.8948 7.15531 22.0009 6.62286 22.0009 6.08505C22.0009 5.54725 21.8948 5.01468 21.6888 4.51791C21.4827 4.02115 21.1807 3.56993 20.8 3.19003ZM8.52003 19.82L6.14003 20.37C6.20037 20.1757 6.23072 19.9734 6.23003 19.77C6.23003 19.2396 6.01932 18.7309 5.64424 18.3558C5.26917 17.9807 4.76046 17.77 4.23003 17.77C4.02698 17.7739 3.8253 17.8042 3.63003 17.86L4.18003 15.49L5.95003 13.7199C7.07497 13.8288 8.13109 14.311 8.95003 15.0899C9.72919 15.9076 10.2086 16.965 10.31 18.0899L8.52003 19.82ZM11.16 17.18C10.9245 16.1122 10.3945 15.1318 9.63003 14.3499C8.84325 13.5869 7.86008 13.0573 6.79003 12.82L14.05 5.58005C15.1746 5.69036 16.2302 6.17244 17.05 6.95004C17.8328 7.76632 18.3158 8.82388 18.42 9.95004L11.16 17.18ZM20.09 8.26999L19.29 9.07004C19.0501 8.00393 18.5206 7.0246 17.76 6.23996C16.9732 5.47689 15.9901 4.94732 14.92 4.71005L15.73 3.89999C16.3091 3.32353 17.0929 2.99985 17.91 2.99985C18.7271 2.99985 19.511 3.32353 20.09 3.89999C20.3782 4.18626 20.6069 4.52671 20.7629 4.9017C20.9189 5.2767 20.9993 5.67889 20.9993 6.08505C20.9993 6.49122 20.9189 6.89329 20.7629 7.26828C20.6069 7.64327 20.3782 7.98373 20.09 8.26999Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 20, 24 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'edit');
export default IconComponent;
